// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style_navigation__1Yu8P","itemActive":"style_itemActive__3zjsY","icon":"style_icon__2ra9w","iconActive":"style_iconActive__2Y6yL"};